<template>
	<tr>
		<td class="py-25">
			<span class="display-flex align-items-center">
				<span class="mr-25">
					<slot name="label"></slot>
				</span>
			</span>
		</td>
		<td class="py-25 text-align-right">
			<span class="display-flex align-items-center justify-content-flex-end">
				<slot name="value"></slot>
			</span>
		</td>
	</tr>
</template>

<script setup lang="ts"></script>
